import { render, staticRenderFns } from "./SmileyRater2.vue?vue&type=template&id=166f7984&"
import script from "./SmileyRater2.vue?vue&type=script&lang=js&"
export * from "./SmileyRater2.vue?vue&type=script&lang=js&"
import style0 from "./SmileyRater2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports